import axios from "axios";
import { getQueryString } from "../utils/Query";

const createBillOfReqHds = async (ReqHds) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/BillOfReqHds`, ReqHds)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllBillOfReqHds = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/BillOfReqHds`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getBillOfReqHds = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/BillOfReqHds/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const editBillOfReqHds = async (id, ReqHds) => {
  return axios
    .patch(`${process.env.REACT_APP_API_URL}/BillOfReqHds/${id}`, ReqHds)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const deleteBillOfReqHds = async (id, force) => {
  return axios
    .delete(
      `${process.env.REACT_APP_API_URL}/BillOfReqHds/${id}?force=${force}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getEquipmentRequisition = async (query) => {
  const params = getQueryString(query)
  return axios
    .get(`${process.env.REACT_APP_API_URL}/BillOfReqHds/present-equipment-requisition${params}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const BillOfReqHdService = {
  createBillOfReqHds,
  getAllBillOfReqHds,
  getBillOfReqHds,
  editBillOfReqHds,
  deleteBillOfReqHds,
  getEquipmentRequisition
};

export default BillOfReqHdService;
